var _defs, _tspan;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 492.59332 222.22267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 166.667h369.445V0H0Z"
  })))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    transform: "matrix(1.33333 0 0 -1.33333 0 222.223)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.533-1.081-1.185-3.126-1.332-4.781-.718-8.263 4.829-14.698 12.085-14.872 6.157-.143 11.625 4.889 12.48 11.685.424 3.388-.668 7.265-1.991 9.426-1.98 3.229-5.785 5.81-11.152 5.311C4.95 6.293 1.583 3.224 0 0m23.497 28.941h10.089V8.761c0-6.885.501-13.869-.528-19.516-1.868-10.219-9.795-18.301-21.906-18.324-6.976-.013-12.167 2.873-15.8 6.509-3.816 3.814-6.66 8.617-7.036 15.133-.38 6.56 2.468 12.458 5.973 16.198 3.972 4.236 9.761 8.15 18.32 7.435 4.553-.382 8.014-3.117 10.758-5.179v17.528c-.014.185-.025.375.13.396",
    style: {
      fill: "fill-opacity:1",
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(160.206 47.105)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.204-9.221 4.411-17.828 13.94-16.862 5.989.611 10.9 6.758 10.49 14.208-.405 7.348-6.211 13.027-14.074 12.081C4.909 8.772 1.052 4.401 0 0m-9.825-28.011c3.145-.601 7.888.783 11.152 0 1.007-.244 2.934-2.453 3.984-3.055 5.225-2.992 12.204-1.801 15.801 1.727 2.536 2.488 3.532 5.389 4.113 9.692-1.276-.905-1.823-2.118-3.184-3.186-5.985-4.713-15.576-4.162-21.775-.266-5.483 3.448-10.217 10.284-10.754 17.657-.591 8.115 2.69 13.824 6.771 17.791 3.572 3.471 8.182 6.187 14.339 6.638 9.223.676 15.297-3.126 19.253-7.965 2.096-2.57 3.562-5.741 4.246-9.294.721-3.749.531-8.243.531-13.011 0-10.03-.682-16.575-4.911-22.172-3.91-5.175-10.24-8.762-18.323-8.762-11.169 0-17.654 6.005-21.243 14.206",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(15.488 44.446)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-.348-8.021 5.552-14.54 13.94-13.676 6.064.629 10.582 6.01 10.754 12.614.116 4.447-2.121 8.786-4.513 10.889-1.854 1.626-5.117 3.29-9.294 2.786C4.757 11.876.281 6.526 0 0m10.753 22.041c6.981.545 13.186-2.281 16.863-5.708 3.602-3.36 6.854-8.758 7.3-15.27.508-7.349-2.266-12.916-5.707-16.863-3.462-3.969-8.732-6.86-15.135-7.3-6.88-.474-12.796 2.288-16.73 5.84-4.124 3.726-6.907 8.382-7.435 15.137-.832 10.644 4.949 18.024 11.948 21.642a23.238 23.238 0 0 0 8.896 2.522",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(64.082 41.26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-3.669-1.74-6.845-5.513-7.303-10.752-.672-7.714 4.345-13.995 10.887-14.606 8.418-.785 14.517 6.111 13.676 14.739C16.619-4.043 11.146 1.907 3.451.931 2.168.769.975.464 0 0m3.318 10.358c7.133.586 13.036-2.264 16.863-5.708 3.661-3.294 7.001-8.564 7.301-15.138.339-7.418-1.953-13.035-5.575-16.994-3.588-3.919-8.687-6.828-15.136-7.302-6.95-.51-12.719 2.293-16.729 5.842-3.983 3.532-7.131 8.353-7.566 14.872-.527 7.83 2.42 13.062 5.708 16.86 3.336 3.856 8.289 7.006 15.134 7.568",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(118.781 52.942)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-2.043-2.042-3.444-4.537-3.72-8.101-.64-8.323 4.73-14.27 11.156-14.87 8.19-.759 14.328 5.951 13.543 14.87-.588 6.663-6.345 12.349-14.073 11.419C3.673 2.931 1.541 1.542 0 0m-13.276-34.119h5.71c1.782 0 4.045.399 5.574 0 1.066-.282 2.372-2.184 3.318-2.792 4.051-2.582 10.237-2.567 14.075-.264 3.709 2.224 5.866 5.997 6.375 11.419-1.355-1.121-2.05-2.344-3.322-3.318-6.713-5.146-17.068-3.526-22.836.661-5.813 4.227-10.165 11.554-9.559 20.582.406 6.07 3.348 10.518 6.771 13.939 3.499 3.5 7.98 6.303 14.341 6.771 7.992.586 14.084-2.485 17.922-6.374 3.532-3.579 5.768-8.617 6.108-14.072.33-5.31 0-10.779 0-16.065 0-5.021-1.145-9.588-2.922-13.011C24.76-43.428 17.161-48.304 8.1-48.325c-11.266-.029-17.716 6.013-21.376 14.206",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(211.453 50.555)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c3.558 4.351 12.281 6.579 18.851 4.645A17.838 17.838 0 0 0 29.34-3.584c4.846-8.418 1.652-23.163 2.391-34.917H21.643c-.429 8.026.563 18.775 0 26.553-.253 3.472-2.326 6.307-5.049 7.435-5.53 2.289-10.884-1.888-11.416-6.635-.449-3.986 0-9.035 0-13.809 0-4.842.107-9.569-.133-13.544H-5.046c-.615 7.911.811 19.222 0 27.081-.352 3.414-2.82 6.267-5.708 7.173-5.404 1.689-10.243-2.375-10.757-7.173-.434-4.078 0-8.851 0-13.537.003-4.589 0-9.221 0-13.544h-10.088c.74 13.333-2.633 27.673 2.921 35.98 2.739 4.095 7.724 7.509 13.94 7.965C-7.799 5.955-3.57 3.165 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(323.221 57.99)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h11.019c3.767-8.803 7.212-17.924 11.155-26.555C25.946-17.761 29.645-8.89 33.324 0H44.21c-8.22-18.821-16.357-37.725-24.562-56.558H9.426c2.405 5.604 4.753 11.266 7.17 16.857C11.184-26.343 5.472-13.295 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "evenodd",
      stroke: "none"
    },
    transform: "translate(244.91 61.974)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c-1.458 10.117-6.385 18.319-14.787 24.603-8.4 6.287-17.672 8.701-27.823 7.23-6.339-.909-12.167-3.39-17.491-7.447-5.045-4.013-8.969-9.016-11.782-15.009l9.817-4.471c2 4.281 4.822 7.891 8.463 10.823a27.78 27.78 0 0 0 4.197 2.771 29.879 29.879 0 0 0 9.502 2.592c4.803.475 9.309-.251 13.5-2.188 6.67-3.08 11.302-8.121 13.883-15.139 2.581-7.008 2.333-13.854-.75-20.53-3.074-6.671-8.12-11.293-15.133-13.876a29.3 29.3 0 0 0-3.723-1.105 26.527 26.527 0 0 0-1.291-.217l-.363-.108c-5.149-.837-10.196-.114-15.151 2.174-4.813 2.221-8.543 5.422-11.188 9.602l9.688-.208.319 9.489-17.837.38v.005l-9.487.206 2.821-27.92 9.857-.274-.971 8.513c2.939-3.872 7.048-7.029 12.331-9.466 8.037-3.711 16.24-4.492 24.608-2.362 8.76 1.951 15.947 6.653 21.555 14.114C-.95-19.414 1.46-10.145 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(258.521 129.96)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0c1.458 10.117 6.389 18.319 14.79 24.603 8.398 6.287 17.672 8.701 27.821 7.23 6.34-.909 12.168-3.39 17.492-7.447 5.041-4.013 8.967-9.016 11.781-15.009l-9.816-4.471c-2.002 4.281-4.823 7.891-8.464 10.823a27.739 27.739 0 0 1-4.198 2.771 29.852 29.852 0 0 1-9.501 2.592c-4.803.475-9.307-.251-13.5-2.188-6.67-3.08-11.3-8.121-13.882-15.139-2.581-7.008-2.335-13.854.747-20.53 3.079-6.671 8.122-11.293 15.136-13.876a29.218 29.218 0 0 1 3.724-1.105c.426-.083.854-.155 1.29-.217l.367-.108c5.142-.837 10.192-.114 15.147 2.174 4.812 2.221 8.542 5.422 11.188 9.602l-9.687-.208-.321 9.489 17.839.38v.005l9.483.206-2.818-27.92-9.858-.274.969 8.513c-2.942-3.872-7.045-7.029-12.329-9.466-8.037-3.711-16.239-4.492-24.607-2.362-8.759 1.951-15.945 6.653-21.556 14.114C.951-19.414-1.457-10.145 0 0",
    style: {
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    transform: "translate(99.832 129.96)"
  })), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.33333 0 0 1.33333 470.924 144.342)",
    style: {
      fontVariant: "normal",
      fontWeight: 700,
      fontStretch: "normal",
      fontSize: "16.928px",
      fontFamily: "Helvetica",
      InkscapeFontSpecification: "Helvetica-Bold",
      writingMode: "lr-tb",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    }
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "\xAE"))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.c621ecf90b770cfc9a9f7dc12fd52346.svg";
export { ForwardRef as ReactComponent };